import r from "./addressService.js";
function t(e) {
  return new r(e).getAddressesLookup;
}
const d = r.searchUri;
function o(e) {
  return new r(e).getAddressDetails;
}
export {
  o as getAddressDetails,
  t as getAddressesLookup,
  d as searchUri
};
